import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CircleIcon from "@mui/icons-material/Circle";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { unicodeToString } from "../../../Js/Common";
import AudioButton from "../../../Components/Media/AudioButton";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const TFS = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [isPlaying1, setIsPlaying1] = useState([]);
  const [isPlaying2, setIsPlaying2] = useState([]);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      setIsPlaying1(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      setIsPlaying2(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );
      let actualAnswers = props.content.epage.options.content.map((val) => {
        if (
          val.collection &&
          (val.collection[0]["answer"] || val.collection[0]["answer"] == "true")
        )
          return "true|false";
        else return "false|true";
      });
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(null)
      )
    );
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index, ans) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      if (newArray[index] == ans) {
        newArray[index] = null;
      } else {
        newArray[index] = ans;
      }
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setPlayMode = (status, index, collection, end) => {
    let arr1 = new Array(props.content.epage.options.content.length).fill(
      false
    );
    let arr2 = new Array(props.content.epage.options.content.length).fill(
      false
    );
    if (status == true && collection == 1 && !end && !isPlaying1[index]) {
      arr1[index] = status;
      setIsPlaying1(arr1);
      setIsPlaying2(arr2);
    }
    if (status == true && collection == 2 && !end && !isPlaying2[index]) {
      arr2[index] = status;
      setIsPlaying1(arr1);
      setIsPlaying2(arr2);
    }

    if (collection == 1 && isPlaying1[index]) {
      setIsPlaying1(arr1);
    }
    if (collection == 2 && isPlaying2[index]) {
      setIsPlaying2(arr2);
    }

    if (end) {
      setIsPlaying1(arr1);
      setIsPlaying2(arr2);
    }
  };

  const setMediaPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <Grid
       
      sx={{ height: "64vh", overflow: "auto", mr: 4 }}
    >
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <List
              dense
              sx={{
                padding: 0,
                my: 3,
                borderBottom: 1,
                borderBottomColor: "#EFEFEF",
                pb: 2,
                mr: 3,
              }}
            >
              <Typography
                color="primary.main"
                sx={{
                  lineHeight: 1.2,
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                  display: "inline-flex",
                }}
              >
                {optionWiseAns && optionWiseAns.length > 0 && (
                  <ListItemIcon>
                    <StatusIndicator
                      correct={optionWiseAns[index]}
                    ></StatusIndicator>
                  </ListItemIcon>
                )}
                {unicodeToString(item.text)}
              </Typography>
              <Grid container sx={{ justifyContent: "space-around", mt: 2 }}>
                <Grid
                  item
                  xs={5}
                  sx={{
                    border: 1,
                    borderRadius: 10,
                    borderColor:
                      userAnswer[index] == "true|false" ? "#DB8829" : "#EFEFEF",
                  }}
                >
                  <ListItem
                    sx={{
                      pa: 0,
                      "@media (min-width: 1636px)": {
                        py: 1,
                      },
                    }}
                    secondaryAction={
                      <IconButton
                        edge="end"
                        aria-label="select"
                        onClick={() => {
                          updateUserAnswer(index, "true|false");
                        }}
                      >
                        <CircleIcon
                          fontSize="small"
                          value="a"
                          name="radio-buttons"
                          sx={{
                            color:
                              userAnswer[index] == "true|false"
                                ? "#DB8829"
                                : "#FFFFFF",
                            border: userAnswer[index] == "true|false" ? 0 : 1,
                            borderColor:
                              userAnswer[index] == "true|false"
                                ? "#DB8829"
                                : "#D9D9D9",
                            borderRadius: "50%",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        />
                      </IconButton>
                    }
                  >
                    {item && item.media && (
                      <OptionMedia
                        media={item.media}
                        isPlaying={currentIndexPlay[index]}
                        setPlayMode={(status, end) => {
                          setMediaPlayMode(status, index, end);
                        }}
                      ></OptionMedia>
                    )}
                    <ListItemText
                      classes={{ primary: classes.ListItemText }}
                      sx={{
                        color: "primary.main",
                        margin: 0,
                        padding: "0.2rem",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "0.9rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      >
                        1.
                        <AudioButton
                          expertAudio={item["collection"][0]["media"]["audio"]}
                          playStatus={(status, end) =>
                            setPlayMode(status, index, 1, end)
                          }
                        >
                          <IconButton
                            sx={{
                              boxShadow: 2,
                              backgroundColor: "#F5F5F5",
                              color: "primary.main",
                              width: "1.5rem",
                              height: "1.5rem",
                              ml: 1,
                              marginTop: "-4px",
                              "@media (min-width: 1636px)": {
                                width: "2.5rem",
                                height: "2.5rem",
                              },
                            }}
                          >
                            {isPlaying1[index] && (
                              <PauseIcon
                                sx={{
                                  fontSize: "1rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                            {!isPlaying1[index] && (
                              <PlayArrowOutlinedIcon
                                color="primary.main"
                                sx={{
                                  fontSize: "1rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        </AudioButton>
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Grid>
                <Grid
                  item
                  xs={5}
                  sx={{
                    border: 1,
                    borderRadius: 10,
                    borderColor:
                      userAnswer[index] == "false|true" ? "#DB8829" : "#EFEFEF",
                  }}
                >
                  <ListItem
                    sx={{
                      pa: 0,
                      height:'100%',
                      "@media (min-width: 1636px)": {
                        py: 1,
                      },
                    }}
                    secondaryAction={
                      <IconButton
                        edge="end"
                        aria-label="select"
                        onClick={() => {
                          updateUserAnswer(index, "false|true");
                        }}
                      >
                        <CircleIcon
                          fontSize="small"
                          value="a"
                          name="radio-buttons"
                          sx={{
                            color:
                              userAnswer[index] == "false|true"
                                ? "#DB8829"
                                : "#FFFFFF",
                            border: userAnswer[index] == "false|true" ? 0 : 1,
                            borderColor:
                              userAnswer[index] == "false|true"
                                ? "#DB8829"
                                : "#D9D9D9",
                            borderRadius: "50%",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        />
                      </IconButton>
                    }
                  >
                    <ListItemText
                      classes={{ primary: classes.ListItemText }}
                      sx={{
                        color: "primary.main",
                        margin: 0,
                        padding: "0.2rem",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "0.9rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      >
                        2.
                        <AudioButton
                          expertAudio={item["collection"][1]["media"]["audio"]}
                          playStatus={(status, end) =>
                            setPlayMode(status, index, 2, end)
                          }
                        >
                          <IconButton
                            sx={{
                              boxShadow: 2,
                              backgroundColor: "#F5F5F5",
                              color: "primary.main",
                              width: "1.5rem",
                              height: "1.5rem",
                              ml: 1,
                              marginTop: "-4px",
                              "@media (min-width: 1636px)": {
                                width: "2.5rem",
                                height: "2.5rem",
                              },
                            }}
                          >
                            {isPlaying2[index] && (
                              <PauseIcon
                                sx={{
                                  fontSize: "1rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                            {!isPlaying2[index] && (
                              <PlayArrowOutlinedIcon
                                color="primary.main"
                                sx={{
                                  fontSize: "1rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        </AudioButton>
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Grid>
              </Grid>
            </List>
          );
        })}
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default TFS;
